import type { DateTime } from 'luxon';

export interface SeriesDataConversionPayload<TValue> {
  [date: string]: TValue;
}

export enum ValueType {
  STANDARD = 'STANDARD',
  ESTIMATED = 'ESTIMATED',
}

export interface SeriesData<TValue> {
  date: DateTime | string;
  valueType?: ValueType;
  value: TValue;
}
